import classNames from 'classnames';
import { ReactElement } from 'react';

import { Field } from '../Field/Field';
import { RadioItem } from '../RadioItem/RadioItem';
import styles from './RadioGroup.styles.m.css';
import { IRadioGroupProps } from './RadioGroup.types';

export const RadioGroup = (props: IRadioGroupProps): ReactElement => {
  const { className, title, name, options, validateFields = [] } = props;

  return (
    <fieldset className={classNames(styles.container, className)}>
      <div className={styles.title}>{title}</div>
      {options.map((option) => {
        return (
          <Field
            key={option.value}
            type="radio"
            name={name}
            value={option.value}
            label={option.label}
            description={option.description}
            component={RadioItem}
            validateFields={validateFields}
          />
        );
      })}
    </fieldset>
  );
};
